<template>
  <div
    class="ccui-menu-wrapper  menu-silder"
    :style="{ height: item.flag ? 'auto' : '30px' }"
  >
    <template v-if="item.flag">
      <el-submenu
        ref="subMenu1"
        :index="resolvePath(item.path)"
        class="sub-menu-silder"
      >
        <template slot="title">
          <span style="color: #4a4a4a;font-size: 14px">{{
            item.meta.title
          }}</span>
        </template>
        <template v-for="citem in item.children">
          <div
            class="ccui-menu-wrapper menu-silder"
            v-if="citem.meta.isShowSideBar"
            style="height: 30px"
            :key="citem.path"
          >
            <app-link :to="resolvePath(citem.path)" :key="citem.path">
              <el-menu-item
                :index="resolvePath(citem.path)"
                :class="{ 'submenu-title-noDropdown': true }"
              >
                <span style="margin-left: 14px">{{ citem.name }}</span>
              </el-menu-item>
            </app-link>
          </div>
        </template>
      </el-submenu>
    </template>
    <template
      v-else-if="
        hasOneShowingChild(item.children, item) &&
          (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
          !item.alwaysShow
      "
    >
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <item
            v-if="onlyOneChild.meta && !onlyOneChild.meta.isNotShow"
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="generateTitle(onlyOneChild.meta.title)"
          />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)">
      <template slot="title">
        <item
          v-if="item.meta && !item.meta.isNotShow"
          :icon="item.meta && item.meta.icon"
          :title="generateTitle(item.meta.title)"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :is-nest="true"
        :item="child"
        :key="child.path"
        :base-path="resolvePath(child.path)"
        class="ccui-nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { generateTitle } from "@/basa/utils/i18n";
import { isExternal } from "@/basa/utils";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      return path.resolve(this.basePath, routePath);
    },

    generateTitle
  }
};
</script>
<style>
.menu-silder .el-submenu__title {
  height: 30px !important;
  line-height: 30px !important;
  text-align: left !important;
}
.ccui-sidebar-wrapper .ccui-sidebar-container .sub-menu-silder .el-menu {
  margin-bottom: 0;
}
.sub-menu-silder .el-submenu__title .el-submenu__icon-arrow {
  display: block !important;
  color: #909399;
}
</style>
